/**
 * 界面语言(2026-09-23)· 简体中文(默认)/ English
 *
 * 代码里照常写中文,给用户看的地方包一层 tr():
 *     tr("销售订单")
 *     tr("已保存「{label}」审批人", { label: row.label })
 * 中文原文就是 key,英文在 ./en/*.ts(按模块分文件,自动合并)。找不到译文 → 原样显示中文。
 * 后端同一套做法(app/i18n),请求头 Accept-Language 告诉它用哪种语言。
 *
 * 同一个中文在不同地方英文不同(按钮「启用」= Enable,状态「启用」= Active):key 后面加 `@@场景`,
 *     tr("启用@@状态")  → 中文界面显示「启用」,英文查 "启用@@状态"(没有再退回 "启用")
 *
 * 切换语言会整页刷新 —— 所以模块顶层的常量(菜单、下拉选项)直接 tr() 也没问题,
 * Element Plus 自带的文字(分页、日期选择器)也一起换。
 * 语言记在本机(localStorage)+ 账号上(users.language),换电脑登录也保持。
 */
import { ref } from "vue";
const LS_KEY = "ui_lang";
const modules = import.meta.glob("./en/*.ts", { eager: true });
const EN = Object.assign({}, ...Object.keys(modules).sort().map((k) => modules[k].default));
function stored() {
    try {
        const v = localStorage.getItem(LS_KEY);
        return v === "zh" || v === "en" ? v : null;
    }
    catch {
        return null;
    }
}
export const lang = ref(stored() || "zh");
export function tr(zh, params) {
    const at = zh.indexOf("@@");
    const base = at >= 0 ? zh.slice(0, at) : zh;
    let s = lang.value === "en" ? (EN[zh] ?? EN[base] ?? base) : base;
    if (params)
        s = s.replace(/\{(\w+)\}/g, (m, k) => (k in params ? String(params[k] ?? "") : m));
    return s;
}
document.documentElement.lang = lang.value === "en" ? "en" : "zh-CN";
document.title = tr("wms-erp · 跨境贸易 ERP");
function remember(l) {
    try {
        localStorage.setItem(LS_KEY, l);
    }
    catch { /* 隐私模式等 · 忽略 */ }
    try {
        const u = JSON.parse(localStorage.getItem("user") || "null");
        if (u) {
            u.language = l;
            localStorage.setItem("user", JSON.stringify(u));
        }
    }
    catch { /* ignore */ }
}
/** 右上角 / 登录页切换:记本机 + 记到账号(已登录时)· 然后整页刷新 */
export async function switchLang(l) {
    if (l === lang.value)
        return;
    remember(l);
    if (localStorage.getItem("token")) {
        try {
            const { default: http } = await import("../api/http");
            await http.put("/api/tenant/me/language", { language: l });
        }
        catch { /* 没存上账号也不影响本机切换 */ }
    }
    location.reload();
}
/** 登录 / 打开系统时拿到账号上的语言:跟本机不一样 → 记下并返回 true(调用方负责刷新页面) */
export function adoptAccountLang(l) {
    if ((l !== "zh" && l !== "en") || l === lang.value)
        return false;
    remember(l);
    return true;
}
//# sourceMappingURL=index.js.map